import React, { useState } from "react";
import { ConfigProvider, Layout, Menu } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";

// import logo from "../assets/logo-text.png";

const { Header, Sider, Content } = Layout;

function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logoutClicked = () => {
    //TODO: api call for token cancellation
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.clear();
    navigate("/login");
  };

  const isAllowed = (allowedRoles) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let userRole = user ? user.role : null;
    let isAllowed = false;
    if (userRole) {
      isAllowed = allowedRoles.find((role) => role == userRole);
    }
    return isAllowed;
  };

  const items = [
    {
      label: "Dashboard",
      path: "dashboard",
      key: "dashboard",
      icon: <HomeOutlined />,
    },
    {
      label: "Quotation",
      path: "quotation",
      key: "quotation",
      permission: ["1", "2"],
      icon: <FileTextOutlined />,
    },
    {
      label: "Authorisation Letter",
      path: "authorisation-letter",
      key: "authorisation-letter",
      permission: ["1", "2"],
      icon: <FileTextOutlined />,
    },
    {
      label: "SEO",
      key: "seo",
      icon: <SettingOutlined />,
      permission: ["1", "2"],
      children: [
        {
          label: "Static Page SEO",
          path: "static-pages-seo",
          key: "static-pages-seo",
          permission: ["1"],
        },
        {
          label: "Product SEO",
          path: "products-seo",
          key: "products-seo",
          permission: ["1"],
        },
        {
          label: "Category SEO",
          path: "categories-seo",
          key: "categories-seo",
          permission: ["1"],
        },
        {
          label: "Subcategory SEO",
          path: "subcategories-seo",
          key: "subcategories-seo",
          permission: ["1"],
        },
        // {
        //   label: "Main Category SEO",
        //   path: "main-categories-seo",
        //   key: "main-categories-seo",
        //   permission: ["1"],
        // },
      ],
    },
    {
      label: "Settings",
      key: "Settings",
      icon: <SettingOutlined />,
      permission: ["1", "2"],
      children: [
        {
          label: "Users",
          path: "setting/users",
          key: "users",
          permission: ["1"],
        },
        {
          label: "Customers",
          path: "setting/customers",
          key: "customers",
          permission: ["1", "2"],
        },
        {
          label: "Products",
          path: "setting/products",
          key: "products",
          permission: ["1"],
        },
        {
          label: "Categories",
          path: "setting/categories",
          key: "categories",
          permission: ["1"],
        },
        {
          label: "Subcategories",
          path: "setting/subcategories",
          key: "subcategories",
          permission: ["1"],
        },
        // {
        //   label: "Category-Subcategory",
        //   path: "setting/category-subcategory",
        //   key: "category-subcategory",
        // },
        // {
        //   label: "Accessory",
        //   path: "setting/accessory",
        //   key: "accessory",
        //   permission: ["1"],
        // },
      ],
    },
    {
      label: "Log Out",
      key: "logout",
      icon: <LogoutOutlined />,
      onClick: logoutClicked,
    },
  ];

  let href = window.location.href?.split("/");
  href = href.slice(-1);

  return (
    <>
      <ScrollToTop />
      <Layout>
        <Sider trigger={null} collapsible collapsed={collapsed} theme="light">
          {/* <div className="logo">
          <img
            style={{ height: 50, width: "100%" }}
            src={logo}
            alt="GPAT Academy"
          />
        </div> */}
          <ConfigProvider
            theme={{
              token: {
                fontSize: 14,
                itemBorderRadius: 16,
              },
            }}
          >
            <Menu
              theme="light"
              mode="inline"
              defaultSelectedKeys={href}
              selectedKeys={href}
              items={items.map((l1_item, index) => {
                let return_status = 0;
                if (l1_item?.permission) {
                  if (isAllowed(l1_item?.permission)) {
                    return_status = 1;
                  }
                } else {
                  return_status = 1;
                }
                return (
                  return_status && {
                    ...l1_item,
                    label: l1_item?.path ? (
                      <Link to={l1_item?.path}>{l1_item?.label}</Link>
                    ) : (
                      <>{l1_item?.label}</>
                    ),
                    children: l1_item?.children?.map((l2_item, l2_index) => {
                      let return_status = 0;
                      if (l2_item?.permission) {
                        if (isAllowed(l2_item?.permission)) {
                          return_status = 1;
                        }
                      } else {
                        return_status = 1;
                      }
                      return (
                        return_status && {
                          ...l2_item,
                          label: (
                            <Link to={l2_item?.path}>{l2_item?.label}</Link>
                          ),
                        }
                      );
                    }),
                  }
                );
              })}
            ></Menu>
          </ConfigProvider>
        </Sider>
        <Layout
          className="site-layout"
          style={{
            minHeight: "100vh",
            width: "100%",
          }}
        >
          <Header style={{ padding: 0 }}>
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: "trigger",
                onClick: toggle,
              }
            )}
          </Header>
          <Content
            style={{
              margin: "24px 16px",
              padding: 5,
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </>
  );
}

export default MainLayout;
